import React, { useEffect, useState, useContext } from "react";
import Layout from "./Layout";
import { UserService } from "../../services/user/userService";
import { CommonService } from "../../services/common/commonService";
import { AuthService } from "../../services/auth/authService";


const UserMasterLayout = () => {
  return (
    <>
      <AuthService>
        <UserService>
          <CommonService>
            <Layout />
          </CommonService>
        </UserService>
      </AuthService>
    </>
  );
};

export default UserMasterLayout;
